module.exports = __webpack_public_path__ + "img/ios.4949dced.jpg";